import { ProjectActionType } from '../actionTypes/project';
import { PostDispatch } from '../types';

const projectReducer = (state = null, action: PostDispatch) => {
    switch (action.type) {
        case ProjectActionType.GET_PROJECT:
        case ProjectActionType.RESET_PROJECT:
        case ProjectActionType.SAVE_PROJECT:
        case ProjectActionType.ACCEPT_GROUP_INVITATION:
        case ProjectActionType.DECLINE_GROUP_INVITATION:
        case ProjectActionType.UPDATE_SECOND_SUPERVISORS:
        case ProjectActionType.REOPEN_PROJECT:
        case ProjectActionType.UPLOAD_PROJECT_FILE:
        case ProjectActionType.CREATE_PLAGIARISM_CHECK_SUBMISSION:
        case ProjectActionType.DISAGREE_GRADE:
        case ProjectActionType.COMPLETE_GRADING:
        case ProjectActionType.ADMIN_APPROVE_DECLINE_PROJECT:
        case ProjectActionType.UPDATE_PROJECT_STATUS:
        case ProjectActionType.ACCEPT_GRADE:
        case ProjectActionType.UPDATE_PROJECT_TITLE:
        case ProjectActionType.UPDATE_PROJECT_DEADLINES:
        case ProjectActionType.UPDATE_PROJECT_DATES:
        case ProjectActionType.ADMIN_ACCEPT_REJECT_PROJECT_REGISTRATION:
        case ProjectActionType.UNLOCK_PROJECT_GRADING:
        case ProjectActionType.RESET_PROJECT_GRADING:
        case ProjectActionType.TOGGLE_FINAL_REPORT_AVAILABILITY:
        case ProjectActionType.ADMIN_SET_AS_FAILED:
        case ProjectActionType.ADMIN_SET_AS_NOT_FAILED:
        case ProjectActionType.ADD_ADDITIONAL_SUPERVISOR:
            return action.payload;
        default:
            return state;
    }
};

export default projectReducer;
